// @flow
import React from 'react';
import classNames from 'classnames';
import { Image } from 'components/atoms/image';
import bedRoomIcon from 'assets/images/bedWhite.png';
import bathRoomIcon from 'assets/images/bathroomWhite.png';
import rupeeIcon from 'assets/images/rupee-icon-pink.png';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  imagePath: string,
  thumbnailUrl?: string,
  price: string,
  containerClass?: string,
  bedCount: number,
  bathCount: number,
};

const RentalHouseCard = (props: Props) => {
  const {
    imagePath,
    thumbnailUrl,
    price,
    containerClass,
    bedCount,
    bathCount,
    onClick,
  } = props;

  const containerClassName = classNames('card-container', containerClass);
  return (
    <div className={containerClassName} onClick={onClick}>
      <div
        className={'card-img-section'}
        style={{ height: `calc(85% - 2.45833vw)` }}
      >
        <Image
          className={'card-image'}
          src={imagePath}
          thumbNail={thumbnailUrl}
          alt={'house-card'}
        />
      </div>
      <div className={'card-info'}>
        <div className={'price-container'}>
          <img src={rupeeIcon} alt={'rupee'} />
          <h3 className={'price-range'}>{price}</h3>
        </div>
        <div className={'image-container'}>
          <div className={'bed-container'}>
            <img className={'bed-img'} src={bedRoomIcon} alt={'bed'} />
            <span className={'bed-count'}>{bedCount}&nbsp;Beds</span>
          </div>
          <div className={'bath-container'}>
            <img className={'bath-img'} src={bathRoomIcon} alt={'bath'} />
            <span className={'bath-count'}>{bathCount}&nbsp;Bath</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentalHouseCard;
